const angular = require('angular');

const productGroupDirectiveDefinition = require('./productgroup.directive');
const { productGroupTileListComponentDefinition } = require('./productgroup-tile-list.component');

angular.module('wowApp.shop')
    .directive('wowProductGroup', ['ProductGroupService', 'OfferGroupService', productGroupDirectiveDefinition])
    .component('wowProductGroupTileList', productGroupTileListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/productgroups/index.js